<template>
	<div class="mask">
		<div class="tip_modal">
			<div class="cont">{{ content }}</div>
			<div class="bot" @click="close">我知道了</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		content: {
			type: String,
			default: () => {
				return "";
			},
		},
	},
	methods: {
		close() {
			this.$emit("closeModal");
		},
	},
};
</script>

<style scoped lang="less">
.mask {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.3);
}
.tip_modal {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 260px;
	height: 139px;
	border-radius: 4px;
	background-color: #fff;
	.cont {
		height: 91px;
		line-height: 91px;
		color: #333;
		font-size: 18px;
		font-weight: 500;
		text-align: center;
	}
	.bot {
		width: 100%;
		height: 47px;
		line-height: 47px;
		font-size: 16px;
		color: #36b374;
		border-top: 1px solid #e5e5e5;
		text-align: center;
	}
}
</style>
